export default "__VITE_ASSET__SYTjjWAr__"